module.exports = __webpack_public_path__ + "img/collection-weddingRingsBudgetHigh@2x.c14a465.webp";